import axiosPrivate from "./axiosPrivate";

export const getPermisos = () => {
  return axiosPrivate.post("getPermisos");
};

export const insertPermiso = (data) => {
  return axiosPrivate.post("permiso-salida", data);
};

export const aprobarJefe = (data) => {
  return axiosPrivate.post("permiso-salida/aprobar-jefe", data);
};

export const rechazarJefe = (data) => {
  return axiosPrivate.post("permiso-salida/rechazar-jefe", data);
};

export const aprobarTH = (data) => {
  return axiosPrivate.post("permiso-salida/aprobar-th", data);
};

export const rechazarTH = (data) => {
  return axiosPrivate.post("permiso-salida/rechazar-th", data);
};

export const guardarArchivoPermiso = (formData) => {
  return axiosPrivate.post("permiso-salida/guardar-archivo", formData, {
    headers: { "Content-Type": "multipart/form-data" }
  });
};

export const updateTipoSalida = (data) => {
  return axiosPrivate.post("permiso-salida/update-tipo-salida", data);
};
